var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile",class:( _obj = {
    disabled: _vm.disabled
  }, _obj[("tile-" + _vm.variant)] = _vm.variant, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }